import { createQuery } from '@tanstack/svelte-query';
import { fetchRCUChannels, fetchRCUChannelsByRCU } from '$lib/api/rcu_channel';
import { resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { RCUChannelResponse } from '$lib/types/rcu_channel';

export const rcuChannelsQuery = () =>
  createQuery<Array<RCUChannelResponse>>(() => ({
    queryKey: ['rcu_channels'],
    queryFn: () => fetchRCUChannels()
  }));

export const rcuChannelsByRCUQuery = (getRcuId: number | ScopeFn) =>
  createQuery<Array<RCUChannelResponse>>(() => {
    const rcuId = resolveScope(getRcuId);
    return {
      queryKey: ['rcu_channels', { rcuId }],
      queryFn: () => fetchRCUChannelsByRCU(rcuId),
      enabled: rcuId > 0
    };
  });
